import React from "react";
import ProjectTemplate from "../components/ProjectTemplate";

const NeurofluxPage = () => {
  const media = [
    '/images/neuroflux_1.webp', 
    '/images/neuroflex_2.webp'
    ];

  return (
    <div className="neuroflux-page">
      <ProjectTemplate
        title="neuro.flux"
        year="2020"
        sections={[
          {
            type: "description",
            text: 'Among other things, this work attempts to create perceptual interactions between sound and image. These interactions can be seen as entanglements on a neurological level between impulses from the senses before and during being processed by the brain. I tried to test the limits of audiovisual unity by looking for the boundaries and working with them. I did this by first unifying the modalities and then focusing on creating specific deviations in particular audio-visual properties and thus creating perceptual disturbances. The "neuro" in the title not only stands for its relation to neurological phenomena, but also to a subgenre of drum and bass called neurofunk, which has inspired the aesthetic of the sounds and rhythms used in the piece.',
          },
          {
            type: "video",
            links: [
              "https://www.youtube.com/embed/KBn0nsj_yjw?si=Ta1AfPLnV9RZ3i-9?&controls=1&color=black&modestbranding=1&rel=0&mode=transparent&autohide=1&showinfo=0",
            ],
          },
          {
            type: "image",
            links: [
              {
                src: media[0]
              }
            ],
            isLink: false,
          },
          {
            type: "image", 
            links: [
              {
                src: media[1]
              }
            ], 
            isLink: false, 
          }
        ]}
      />
    </div>
  );
};

export default NeurofluxPage;
